import { z } from 'zod'

export const SESSION_STATUS = {
  starting: 'starting',
  active: 'active',
  stopping: 'stopping',
  stopped: 'stopped',
  failed: 'failed',
} as const
export const sessionStatusSchema = z.nativeEnum(SESSION_STATUS)
export type SessionStatus = keyof typeof SESSION_STATUS
